import { Box, Button, Grid, Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import AnimateButton from './extended/AnimateButton';
import React from 'react';

export const DefaultTitleText = ({ title }) => {
    return (
        <Typography id="modal-modal-title" variant="h3" component="h3" sx={{ whiteSpace: 'pre-line' }}>
            {title}
        </Typography>
    );
};

export const DefaultContentText = ({ content }) => {
    return (
        <Typography id="modal-modal-description" sx={{ mt: 2, whiteSpace: 'pre-line' }}>
            {content}
        </Typography>
    );
};

export const DefaultButton = ({ buttonTitle, onClose }) => {
    return (
        <Grid direction="row" container spacing={1} mt={3} justifyContent="end">
            <Grid item>
                <AnimateButton>
                    <Button disableElevation fullWidth size="large" type="button" variant="contained" color="primary" onClick={onClose}>
                        {buttonTitle?.length > 0 ? buttonTitle : '확인'}
                    </Button>
                </AnimateButton>
            </Grid>
        </Grid>
    );
};

export const DefaultTextModal = ({ title, content, buttonTitle, ...rest }) => {
    return (
        <DefaultModal
            title={DefaultTitleText({ title: title })}
            content={DefaultContentText({ content: content })}
            button={DefaultButton({ buttonTitle: buttonTitle, onClose: rest.onClose })}
            {...rest}
        />
    );
};

export const DefaultModal = ({ title, content, button, ...rest }) => {
    return (
        <Modal {...rest}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: 4,
                    p: 4
                }}
            >
                {title}
                {content}
                {button}
            </Box>
        </Modal>
    );
};
